// src/components/PauseBanner.jsx
//
// Banda de aviso en las páginas que siguen abiertas al público durante la
// pausa del servicio: la landing, términos, privacidad, soporte, el login
// y la recuperación de contraseña.
//
// Solo en esas. En el dashboard, en /app y en el checkout no hace falta,
// porque ahí ya se muestra la pantalla de pausa completa, y repetir el
// mensaje sobraría.
//
// Ojo con una confusión que arrastrábamos: /aprende y /como-funciona
// parecen públicas por la carpeta en la que viven, pero están detrás de
// ProtectedRoute con requireAccess. No son públicas y por eso no llevan
// banner: a un cliente le sale la pantalla de pausa.

import { useLocation } from 'react-router-dom';
import { SERVICE_PAUSED, PAUSE_COPY } from '../config/servicePaused';

// Rutas realmente públicas, las únicas donde el banner tiene sentido.
const PUBLICAS = [
  '/',
  '/login',
  '/terminos',
  '/privacidad',
  '/soporte',
  '/senales-gratis',
  '/recuperar',
  '/recuperar/enviado',
];

export default function PauseBanner() {
  const { pathname } = useLocation();

  if (!SERVICE_PAUSED) return null;
  if (!PUBLICAS.includes(pathname)) return null;

  return (
    <div
      role="status"
      style={{
        position: 'relative',
        zIndex: 40,
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px 16px',
        textAlign: 'center',
        fontSize: 13,
        lineHeight: 1.5,
        color: '#1a1205',
        background: 'var(--amber, #f4b740)',
        borderBottom: '1px solid rgba(0,0,0,.14)',
      }}
    >
      {PAUSE_COPY.banner}
    </div>
  );
}
